import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'phoneInput',
    'phoneWrapper',
    'sendButton',
    'codeWrapper',
    'pinError',
    'phoneRow',
    'codeRow',
    'phoneVerifiedInfo',
    'phoneVerifiedContinue',
  ];

  initialize() {
    this.canEnableButton = true;

    Siepomaga.cleanOnLoad(() => {
      $('#sms-pin').empty();
    });

    this.pinlogin = $('#sms-pin').pinlogin({
      fields: 6,
      hideinput: false,
      reset: false,
      autofocus: false,
      complete: (pin) => {
        this.codeEntered(pin);
      },
    });

    this.pinlogin.disable();

    $('input[id^="sms-pin_pinlogin_"]').offon('focus click keypress', () => {
      $('#sms-pin-error').slideUp(() => {
        $('#sms-pin-error').empty();
      });
    });

    this.codeWrapperTarget
      .querySelectorAll('.pinlogin-field')
      .forEach((item) => {
        item.setAttribute('inputmode', 'numeric');
      });
  }

  handlePhoneValidation(event) {
    const validationSuccessful = event.detail.success;

    if (validationSuccessful && this.canEnableButton) {
      this.sendButtonTarget.removeAttribute('disabled');
    } else {
      this.sendButtonTarget.setAttribute('disabled', 'disabled');
    }
  }

  maybeAppendSlash(url) {
    if (url.slice(-1) !== "/") {
        url += "/";
    }
    return url;
  }

  // based on: https://stackoverflow.com/questions/26367803/append-trailing-slash-to-every-outgoing-ajax-request-with-jquery
  // makes sure that AJAX request always hits <current_url>/generate_code or <current_url>/validate_code
  // without it this bahavior depends on whether or not the <current_url> ends with / (slash)
  ensureTrailingSlash(url) {
    var parser = document.createElement("a");
    parser.href = window.location.pathname;
    parser.pathname = this.maybeAppendSlash(parser.pathname);
    return parser.href + url;
  }

  generateCode() {
    this.sendButtonTarget.setAttribute('disabled', 'disabled');
    this.phoneNumber = this.phoneInputTarget.value;

    if (this.phoneWrapperTarget.dataset.controller === 'intl-phone-input') {
      const hidden_input = this.phoneInputTarget.parentNode.querySelector(
        'input[type="hidden"]',
      );
      if (hidden_input !== undefined) {
        this.phoneNumber = hidden_input.value;
      }
    }

    $.ajax({
      method: 'POST',
      url: 'generate_code',
      dataType: 'json',
      data: {
        phone: this.phoneNumber,
      },
      beforeSend: (xhr, settings) => {
        settings.url = this.ensureTrailingSlash(settings.url);
      },
      success: (response) => {
        if (response.success) {
          this.canEnableButton = false;
          if (this.phoneWrapperTarget.classList.contains('field_with_errors')) {
            this.phoneWrapperTarget.classList.remove('field_with_errors');
            $(this.phoneWrapperTarget.querySelector('.error')).slideUp(() => {
              this.phoneWrapperTarget.removeChild(
                this.phoneWrapperTarget.querySelector('.error'),
              );
            });
          }
        } else {
          this.phoneWrapperTarget.classList.add('field_with_errors');

          if (!this.phoneWrapperTarget.querySelector('.error')) {
            const div = document.createElement('div');
            div.classList.add('error');
            div.textContent = response.message;
            this.phoneWrapperTarget.appendChild(div);
          }
        }
      },
      error: () => {
        alert('Coś poszło nie tak, jak powinno! Spróbuj ponownie.');
      },
      complete: () => {
        this.pinlogin.enableField(0);
        this.pinlogin.focus(0);

        Siepomaga.timeout(60000, () => {
          this.canEnableButton = true;
          this.sendButtonTarget.removeAttribute('disabled');
        });
      },
    });
  }

  codeEntered(pin) {
    $('#sms-pin_pinlogin_5').blur();
    this.pinlogin.disable();

    Siepomaga.timeout(1, () => {
      // IE 11
      $.ajax({
        method: 'POST',
        url: 'validate_code',
        dataType: 'json',
        data: {
          code: pin,
          phone: this.phoneNumber,
        },
        beforeSend: (xhr, settings) => {
          settings.url = this.ensureTrailingSlash(settings.url);
        },
        success: (response) => {
          if (response.success) {
            Array.prototype.forEach.call(
              this.codeWrapperTarget.querySelectorAll(
                '[id^="sms-pin_pinlogin_"]',
              ),
              (el) => {
                el.setAttribute('disabled', 'disabled');
              },
            );
            this.phoneVerifiedInfoTarget.classList.remove('hidden');
            this.sendButtonTarget.classList.add('verified');
            this.codeRowTarget.classList.add('hidden');
            this.phoneInputTarget.setAttribute('disabled', 'disabled');
            if (this.hasPhoneVerifiedContinueTarget) {
              this.phoneVerifiedContinueTarget.removeAttribute('disabled');
            }
            if (
              this.phoneWrapperTarget.classList.contains('field_with_errors')
            ) {
              this.phoneWrapperTarget.removeChild(
                this.phoneWrapperTarget.querySelector('.error'),
              );
              this.phoneWrapperTarget.classList.remove('field_with_errors');
            }
            if (
              this.phoneWrapperTarget.dataset.controller === 'intl-phone-input'
            ) {
              const hidden_input =
                this.phoneInputTarget.parentNode.querySelector(
                  'input[type="hidden"]',
                );
              if (hidden_input !== undefined) {
                hidden_input.setAttribute('disabled', 'disabled');
              }
            }
            $('.initially-disabled').removeAttr('disabled');
          } else {
            Siepomaga.timeout(5000, () => {
              this.pinlogin.enable();
              this.pinErrorTarget.textContent = response.message;
              this.pinErrorTarget.style.display = 'block';
            });
          }
        },
        error: () => {
          alert('Coś poszło nie tak, jak powinno! Spróbuj ponownie.');
          this.pinlogin.enable();
        },
      });
    });
  }
}
